import React, {PureComponent, createRef} from "react";
import classNames from 'classnames';
import styles from './FJSearchList.module.less'
import FJCustomScroll from "fj-components/FJCustomScroll";
import FJToolContent from "fj-components/FJToolContent";
import FJFixedLayout from "fj-components/FJFixedLayout";
import FJResourcesElementCommon from "./FJResourcesElementCommon";
import InlineSVG from "react-inlinesvg";
import searchEmptySvg from '../../../icon/search_empty.svg';
import FJLocalStore from "../../../store/FJLocalStore";
import FJSearchLoading from "./FJSearchLoading";
import FJCoreUtil from "../../../core/util/FJCoreUtil";

class FJSearchList extends PureComponent{

	constructor(props) {
		super(props);
		this.state = {
		  couldNextPage: true,
    };
		this.scrollRef = createRef();
	}

  componentDidUpdate(prevProps, prevState, snapshot) {
	  if (!this.props.fetchLoading && prevProps.fetchLoading) {
	    setTimeout(() => {
	      this.setState({couldNextPage: true})
      })
    }

		if (prevProps.keyword !== this.props.keyword) {
			this.scrollRef.current.scrollTop(0, true)
		}

		if (this.props.jumpScroll) {
			this.scrollRef.current.scrollTop(this.scrollLocation - 200, true)
			this.props.resetJumpScroll();
		}
  }

  _renderLayout = (itemWidth, space, column) => {
    let {
      resourceViewInfo,
      list,
      onAddClick,
      onHandleClick,
      onMediaDrag,
      classes,
      config,
      allTooltip,
      toggleTooltip,
      oneTooltip,
      chooseMediaIdList,
    } = this.props;

    let {
      height,
      marginBottom,
      marginLeft = 0
    } = resourceViewInfo;

    let {
      addIcon,
      deleteIcon,
      activeColor,
      addIconToolTip,
    } = config;
    let itemHeight = height;

    return list.map((item, index) => (
      <FJResourcesElementCommon
        key={item.id}
        id={item.id}
        width={itemWidth}
        height={itemHeight}
        marginRight={(index + 1) % column === 0 ? 0 : space}
        marginBottom={marginBottom}
        marginLeft={marginLeft}
        fromType={item.fromType}
        thumbnail={item.thumbnail}
        url={item.url}
        name={item.title}
        hasName={false}
        type={item.type}
        hasAddBtn
        onAddClick={onAddClick}
        selectMedia={onHandleClick}
        classes={classes.itemClasses}
        contentClassName={styles.item_content}
        activeColor={activeColor}
        addIcon={addIcon}
        deleteIcon={deleteIcon}
        onMediaDrag={onMediaDrag}
        addIconToolTip={addIconToolTip}
        allTooltip={allTooltip}
        toggleTooltip={toggleTooltip}
        oneTooltip={oneTooltip}
        isChoose={chooseMediaIdList.indexOf(item.name) !== -1}
        authorItem={item.authorItem}
      />
    ))
  };

  _getCollectionList = () => {
    let {resourceViewInfo, list} = this.props;
    let {width, space} = resourceViewInfo;
    return <FJFixedLayout
      basicWidth={width}
      space={space}
      active={list.length}
      render={this._renderLayout}
    />
  }

  /**
   * @description 监听滚动到底部时加载更多
   * @param event
   * @private
   */
  _onScroll = (event) => {
		FJCoreUtil.triggerBodyMousedown();
		this.scrollLocation = event.target.scrollTop + event.target.clientHeight;
    if(this.state.couldNextPage && event.target.scrollTop + event.target.clientHeight === event.target.scrollHeight
      && !this.props.fetchLoading) {
      this.setState({couldNextPage: false}, () => {
        this.props.nextPage(this.scrollRef.current, event.target.scrollTop);
      });
    }
  }

  _render = () => {
    let {classes, fetchLoading} = this.props;
    return (
      <div className={ classNames(styles.inner, classes.textMoreInnerBox) }>
        {this._getCollectionList()}
        <FJSearchLoading active={fetchLoading}/>
      </div>
    );
  };

  render() {

		let {
			isShow,
			classes,
			list,
			keyword,
			fetchLoading
		} = this.props;

		let cn = classNames(styles.container, {[styles.active]: isShow})
		keyword= keyword.length > 50 ? keyword.substring(0, 30) + '...' : keyword;

		return (
			<div className={cn}>
				{
					(!list.length && !fetchLoading) ? <NoSearchResult keyword={keyword}/> : (
						<FJToolContent active>
							<FJCustomScroll classes={classes.scrollClasses}
                              onScroll={this._onScroll}
                              render={this._render}
                              ref={this.scrollRef} />
						</FJToolContent>
					)
				}
			</div>
		)
	}
}

function NoSearchResult(props) {

	let {
		keyword
	} = props;

	let cn = classNames(styles.no_result)

	return (
		<div className={cn}>
			<div>
				<div className={styles.empty_svg_box}>
					<InlineSVG src={searchEmptySvg}/>
				</div>
				<div className={styles.text_box}>
					<p className={styles.content}>{FJLocalStore._('search tips').replace('xxx',keyword)}</p>
				</div>
			</div>
		</div>
	)

}

export default FJSearchList;